export type FilterDateRange =
  | "last30days"
  | "last180days"
  | "last365days"
  | "last180days"
  | "currentmonth"
  | "lastmonth"
  | "lastyear"
  | "currentyear";
export const convertRangeToDate = (
  range: FilterDateRange
): { firstDay: Date; lastDay: Date } => {
  const curDate = new Date();
  let firstDay = new Date();
  let lastDay = new Date();
  firstDay.setHours(0, 0, 0, 0);
  lastDay.setHours(23, 59, 59, 999);
  switch (range) {
    case "last30days":
      firstDay.setDate(firstDay.getDate() - 30);
      break;
    case "last365days":
      firstDay.setDate(firstDay.getDate() - 365);
      break;
    case "last180days":
      firstDay.setDate(firstDay.getDate() - 180);
      break;
    case "currentmonth":
      firstDay = new Date(curDate.getFullYear(), curDate.getMonth(), 1);
      lastDay = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0);
      lastDay.setHours(23, 59, 59, 999);
      break;
    case "lastmonth":
      firstDay = new Date(curDate.getFullYear(), curDate.getMonth() -1, 1);
      lastDay = new Date(curDate.getFullYear(), curDate.getMonth(), 0);
      lastDay.setHours(23, 59, 59, 999);
      break;
    case "lastyear":
      const lastYear = new Date(new Date().getFullYear() - 1, 0, 1);
      firstDay = new Date(lastYear.getFullYear(), 0, 1);
      lastDay = new Date(lastYear.getFullYear(), 11, 31);
      lastDay.setHours(23, 59, 59, 999);
      break;
    case "currentyear":
      firstDay = new Date(curDate.getFullYear(), 0, 1);
      lastDay = new Date(new Date().getFullYear(), 11, 31);
      lastDay.setHours(23, 59, 59, 999);
      break;
    case "all":
      firstDay = new Date(curDate.getFullYear() - 20, curDate.getMonth(), 1);
      lastDay = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0);
      lastDay.setHours(23, 59, 59, 999);
      break;
  }
  return { firstDay, lastDay };
};

export const unixToTime = (unixDate: string) => {
  const date = new Date(unixDate);
  const fullDate =
    date.getDate() +
    "." +
    (date.getMonth() + 1) +
    "." +
    date.getFullYear() +
    " " +
    date.getHours() +
    ":" +
    ("0" + date.getMinutes()).substr(-2) +
    ":" +
    ("0" + date.getSeconds()).substr(-2);
  return fullDate;
};
